import { defineField, defineType } from 'sanity'

import AccessoriesSkus from '../../components/AccessoriesSkus'

export default defineType({
  name: 'accessoryConfiguration',
  title: 'Accessory Configuration',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'skus',
      title: 'Product SKUs',
      description: 'Comma separated skus can be used for searching',
      type: 'string',
      components: {
        input: AccessoriesSkus,
      },
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'New Configuration' }) {
      return {
        title,
      }
    },
  },
})